export default __webpack_public_path__ + "static/Tek_Ramp-ad907f86790e8735dda42f477c439750.png";